<template>
  <div>
    <page-header title="舆情报告" description="沉淀公开原文、评论和风险处置结论" />
    <el-card v-loading="loading">
      <el-empty v-if="!report" description="完成公开舆情采集后生成报告" />
      <div v-else>
        <div class="actions"><el-button size="mini" @click="download('xlsx')">导出 XLSX</el-button><el-button size="mini" type="primary" @click="download('pdf')">导出 PDF</el-button></div>
        <pre>{{ report }}</pre>
      </div>
    </el-card>
    <el-card class="mt" shadow="never"><el-descriptions :column="1" size="small"><el-descriptions-item label="报告范围">公开原文、原评论、链接和风险处置证据</el-descriptions-item></el-descriptions></el-card>
  </div>
</template>
<script>
import { yuqingApi } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
export default {
  components: { PageHeader },
  data () { return { loading: false, run: null, report: '' } },
  mounted () { this.load() },
  methods: {
    async load () { this.loading = true; try { const latest = await yuqingApi.get('runs/latest'); this.run = latest.run; if (this.run) { const detail = await yuqingApi.get(`runs/${this.run.id}`); this.report = detail.report || '' } } catch (error) { this.$message.error(error.message) } finally { this.loading = false } },
    download (type) { if (this.run) yuqingApi.download(`runs/${this.run.id}/report.${type}`) }
  }
}
</script>
<style scoped>.mt{margin-top:16px}.actions{margin-bottom:12px;text-align:right}pre{white-space:pre-wrap;word-break:break-word;line-height:1.8;font-family:inherit}</style>
